import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-cust-facts',
  templateUrl: './cust-facts.component.html',
  styleUrls: ['./cust-facts.component.css']
})
export class CustFactsComponent implements OnInit {
    custNo;

    public setting?: Setting;

    public inputListCustomerFacts: CustomerFactItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.custNo = this.stateService.getStateParams()['cust_no'];
    }

    private async loadSetting() {
        if (!!this.custNo) {
            this.setting = (await this.datatask.Post(2912, { cust_no: this.custNo }))[0];
        }
    }

    private async loadCustomerFacts() {
        if (!!this.setting) {
            this.inputListCustomerFacts = await this.datatask.Post(2913, this.setting);
        }
    }

    public async saveChanges() {
        if (!!this.setting && !!this.inputListCustomerFacts) {
            try {
                this.saving = true;

                let mergeObj: any = {};
                mergeObj = this.setting;
                mergeObj.custfacts = [];
                mergeObj.custfacts = this.inputListCustomerFacts;

                const response = (await this.datatask.Post(2914, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCustomerFacts();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    cust_no: number;
    page_heading: string;
}

interface CustomerFactItem {
    custfact_lineno: number;
    facts_name: string;
    checkbox: number;
    orderby: number;
    elementtype: string;
    number: string;
    note: string;
}
